import * as Yup from 'yup';

export const validationSchemaCampaign = Yup.object().shape({
  // campaignName: Yup.string().required("Campaign Name is required"),
  campaignTypeId: Yup.string().required('Type is required'),

  campaignName: Yup.string().required('Campaign Name is required'),

  // startDate: Yup.date()
  //     .transform((value, originalValue) => {
  //         if (originalValue && typeof originalValue === 'string') {
  //             const date = new Date(originalValue);
  //             return isNaN(date) ? undefined : date;
  //         }
  //         return originalValue;
  //     })
  //     .nullable(),

  // endDate: Yup.date()
  //     .transform((value, originalValue) => {
  //         if (originalValue && typeof originalValue === 'string') {
  //             const date = new Date(originalValue);
  //             return isNaN(date) ? undefined : date;
  //         }
  //         return originalValue;
  //     })
  //     .nullable()
  //     .test('end-date-check', 'End date cannot be before start date', function(endDate) {
  //         const { startDate } = this.parent;
  //         if (!startDate || !endDate) return true;
  //         return new Date(endDate) >= new Date(startDate);
  //     }),

  senderEmail: Yup.string().required('Sender is required'),

  templateId: Yup.string().required('Template is required'),

  scheduledDateTime: Yup.string()
    .required('Schedule At is required')
    .test(
      'is-valid-schedule-time',
      'Schedule date must be at least 15 minutes in the future from current date time',
      (value) => {
        if (!value) return false;
        const selectedDate = new Date(value);
        const now = new Date();
        const minAllowedTime = new Date(now.getTime() + 15 * 60 * 1000);
        return selectedDate > minAllowedTime;
      }
    ),

  campaignFor: Yup.string().required('Campaign For is required'),
});
